import React from "react";
import PropTypes from "prop-types";
import { PrimaryButtonLink, PrimaryButton, ButtonLink } from "../../../components/Buttons";
import { connect } from "react-redux";
import { exportWorkers } from "../actions";
import { Organisation } from "../../Permissions/resources";
import {
  isResourceEditable,
  isResourceReadable,
} from "../../Permissions/actions";
import { W3Dropdown, W3DropdownContent, W3DropdownToggler } from "../../../components/W3Dropdown";

const mapStateToProps = (state) => ({
  permissions: state.permissions.permissionMap,
});
const mapDispatchToProps = (dispatch) => ({
  getWorkersAsCSV: (...args) => dispatch(exportWorkers(...args)),
});

class WorkerListMenu extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    permissions: PropTypes.shape({}).isRequired,
    getWorkersAsCSV: PropTypes.func.isRequired,
  };
  static defaultProps = {
    className: "",
  };
  onExportWorkers = (event) => {
    if (event) event.preventDefault();
    this.props.getWorkersAsCSV();
  };
  render() {
    const { className, permissions } = this.props;
    const isReadable = isResourceReadable(
      Organisation.WorkerWizard.BasicInfo,
      permissions
    );
    const isEditable = isResourceEditable(
      Organisation.WorkerWizard.BasicInfo,
      permissions
    );
    const isImportReadable = isResourceReadable(
      Organisation.WorkerWizard.Import,
      permissions
    );
    return (
      <div className={`worker list-menu ${className}`}>
        {((isReadable && isEditable) || isImportReadable) && (
          <W3Dropdown className="modems dropdown-list-menu">
            <W3DropdownToggler
              as={PrimaryButton}
              size=""
              name="addWorkerBtn"
            >{`Mitarbeiter hinzufügen`}
            </W3DropdownToggler>
            <W3DropdownContent
              className="w3-bar-block w3-border"
              style={{ right: "0", width: "180px" }}
            >
              {isReadable && isEditable && (
                <ButtonLink
                  className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                  to={`/wizard/organisation/mitarbeiter/neu`}
                >
                  {`Einzelanlage`}
                </ButtonLink>
              )}
              {isImportReadable && (
                <>
                  <a href="#" className="w3-bar-item separator">
                    <div className="w3-border-top" style={{margin: '0 -4px'}}/>
                  </a>
                  <ButtonLink
                    className="w3-bar-item dropdown-list-menu-item bg-secondary-hover"
                    to={`/wizard/organisation/mitarbeiterimport`}
                  >
                    {`Import`}
                  </ButtonLink>
                </>
              )}
            </W3DropdownContent>
          </W3Dropdown>
        )}
        <PrimaryButton
          className="margin-lft"
          name="exportWorkerBtn"
          onClick={this.onExportWorkers}
        >
          {"CSV Exportieren"}
        </PrimaryButton>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(WorkerListMenu);
